import { Document, Font } from '@react-pdf/renderer';
import format from 'date-fns/format';
import { SkillsMemberCertificationModelList } from 'generated-types/skills/certification';
import { SkillsEducationModelList } from 'generated-types/skills/education';
import { SkillsExperienceModelList } from 'generated-types/skills/experience';
import { SkillsMemberModel } from 'generated-types/skills/member';
import { SkillsMemberSkillModelList } from 'generated-types/skills/skill';

// @ts-ignore @eslint-ignore
import montserratBold from '../../../../assets/fonts/Montserrat-Bold.ttf';
// @ts-ignore @eslint-ignore
import montserratRegular from '../../../../assets/fonts/Montserrat-Regular.ttf';
// @ts-ignore @eslint-ignore
import openSansLight from '../../../../assets/fonts/OpenSans-Light.ttf';
// @ts-ignore @eslint-ignore
import openSansRegular from '../../../../assets/fonts/OpenSans-Regular.ttf';
import { ClosingPage } from './ClosingPage';
import { EducationPage } from './EducationPage';
import { ExperiencePage } from './ExperiencePage';
import { IntroductionPage } from './IntroductionPage';
import { SkillsPage } from './SkillsPage';
import { ResumeProfileModel } from 'generated-types/skills/resume_profile';

export const PdfCV = ({
    selectedResumeProfile,
    member,
    skills,
    certifications,
    otherExperiences,
    circlesExperiences,
    educations,
    externalPicture,
    anonymous,
}: {
    selectedResumeProfile: ResumeProfileModel;
    member: SkillsMemberModel;
    skills: SkillsMemberSkillModelList;
    certifications: SkillsMemberCertificationModelList;
    otherExperiences: SkillsExperienceModelList;
    circlesExperiences: SkillsExperienceModelList;
    educations: SkillsEducationModelList;
    externalPicture?: string;
    anonymous?: boolean;
}) => {
    const companyName = 'Circles Consulting';
    const footerText = anonymous
        ? `${companyName} - ${format(new Date(), 'dd.MM.yyyy')} | `
        : `${member.firstname} ${member.lastname} - ${companyName} - ${format(new Date(), 'dd.MM.yyyy')} | `;

    Font.register({
        family: 'Montserrat',
        fonts: [{ src: montserratRegular }, { src: montserratBold, fontWeight: 'bold' }],
    });
    Font.register({
        family: 'OpenSans',
        fonts: [
            {
                src: openSansRegular,
            },
            {
                src: openSansLight,
                fontWeight: 'light',
                fontStyle: 'normal',
            },
        ],
    });

    const renderSkillsPage = skills.some(
        skill =>
            skill?.level && skill.level > 0 && selectedResumeProfile.skill_ids.includes(skill.id),
    );
    const renderCircleExperiencePage = circlesExperiences.length > 0;
    const renderOtherExperiencePage = otherExperiences.length > 0;
    const renderEducationPage = educations.length > 0 || certifications.length > 0;

    return (
        <Document
            title={anonymous ? 'Circles CV' : `CV ${member.firstname} ${member.lastname}`}
            author={anonymous ? companyName : `${member.firstname} ${member.lastname}`}
            creator={companyName}
            producer="my.circles.fi"
        >
            <IntroductionPage
                member={member}
                externalPicture={externalPicture}
                selectedResumeProfile={selectedResumeProfile}
                anonymous={anonymous}
            />
            {renderSkillsPage && (
                <SkillsPage
                    selectedResumeProfile={selectedResumeProfile}
                    skills={skills}
                    footerText={footerText}
                />
            )}
            {renderCircleExperiencePage && (
                <ExperiencePage
                    experiences={circlesExperiences}
                    footerText={footerText}
                    pageTitle={`Experience at ${companyName}`}
                />
            )}
            {renderOtherExperiencePage && (
                <ExperiencePage
                    experiences={otherExperiences}
                    footerText={footerText}
                    pageTitle="Work Experience"
                />
            )}
            {renderEducationPage && (
                <EducationPage
                    educations={educations}
                    footerText={footerText}
                    certifications={certifications}
                />
            )}
            <ClosingPage />
        </Document>
    );
};
